import { AnimatePresence, motion } from 'framer-motion';
import React, { useContext, useState } from 'react'
import { TfiAngleRight } from "react-icons/tfi";
import { BiCog } from 'react-icons/bi';
import { Link, useLocation } from 'react-router-dom';
import { GoPlus } from "react-icons/go";
import { AiOutlineMinus } from "react-icons/ai";
import { IoIosArrowDown } from 'react-icons/io';

const NestedLink = ({ Icon, title, to, links }) => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <>
    <div className='relative'>

    <button onClick={() => setOpen(!open)} className={`mb-2 w-full rounded-[6px]  group flex space-x-2 py-3 px-4 items-center justify-between ${open ? "text-primary font-bold" : ""}`}>
      <div className='flex items-center space-x-2'>
        {/* <img src={icon} className={`flex-shrink-0 mr-3 w-[20px] ${open ? "" : "opacity-[0.65]"}`} /> */}
        <Icon className={`flex-shrink-0 group-hover:text-primary text-xl text-t-light `}/>
        <span className={`text-sm font-medium group-hover:text-primary text-t-light`}>
          {
            title
          }
        </span>
      </div>
      {
        // open ?
          <IoIosArrowDown className={`flex-shrink-0 group-hover:text-primary text-t-light text-lg transition-transform duration-200  ${open ? "rotate-[180deg]" : " rotate=[0deg]"}`} />
        // :
        //   <GoPlus className={`flex-shrink-0 group-hover:text-primary text-lg ${open ? "rotate-[90deg] text-primary" : "text-t-light rotate=[0deg]"}`} />

      }
    </button>
      <AnimatePresence>
        {
          open &&
          <motion.div
            initial={{ height: "0" }}
            animate={{ height: "auto" }}
            exit={{ height: "0" }}
            className="mb-2 pl-5 overflow-hidden w-[90%] mx-auto relative"
          >
           <div className='border-l-2 border-dashed border-primary/40 space-y-1'>
            {
                links.map((item, index) => (
                    <Link key={index} to={item.to} className={`mb-2 transition-all  w-[90%] mx-auto group hover:font-bold rounded-lg justify-start flex items-center py-3 px-3`}>
                      
                      <span className={`text-sm font-medium ${item.to === pathname ? "font-semibold text-primary" : "text-t-light group-hover:text-primary group-hover:font-medium"}`}>
                        {
                          item.title
                        }
                      </span>
                    </Link>
                ))
              }
           </div>
          </motion.div>

        }
      </AnimatePresence>
    </div>

    </>
  )
}

export default NestedLink